export default "__VITE_ASSET__DEtxH1ol__"